import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { FormAlert, NewInputText, parseFinalFormErrors } from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import validate from '@saucelabs/sl-util-validate';

const constraints = {
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
};

const ChangeEmailForm = ({ changeEmail, formHandler, username }) => (
  <Form
    onSubmit={(values) => (
      changeEmail({ ...values, username })
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => {
          parseFinalFormErrors({}, response.data.message);
        })
    )}
    render={({ form, handleSubmit }) => {
      formHandler.submit = handleSubmit; // eslint-disable-line no-param-reassign
      const { error, submitError } = form.getState();

      return (
        <form onSubmit={handleSubmit}>
          <FormAlert type="danger">{error || submitError}</FormAlert>
          <Row>
            <Col xs={12}>
              <Field
                className="form-control"
                component={NewInputText}
                label="New Email"
                name="email"
                type="email"
              />
            </Col>
          </Row>
        </form>
      );
    }}
    validate={(values) => validate(values, constraints)}
  />
);

ChangeEmailForm.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  formHandler: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  username: PropTypes.string.isRequired,
};

export default ChangeEmailForm;
export { ChangeEmailForm };
